// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

import angular from 'angular'
import { ITimeoutService } from 'angular'

let key
const SNAKE_CASE_REGEXP = /[A-Z]/g

const snake_case = function (name: string, separator: string = '_'): string {
   return name.replace(SNAKE_CASE_REGEXP, (letter: string, pos: number) => (pos ? separator : '') + letter.toLowerCase());
}

// Altmetrics attributes. Those will be represented as needed adding in a batch the 'data-' prefix in case they are set
const AltmetricsConfigAttributes = ['badgeType', 'badgePopover', 'badgeDetails', 'noScore', 'hideLessThan', 'condensed']

const AltmetricsComposedScope = {}
// @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
for (key of AltmetricsConfigAttributes) { AltmetricsComposedScope[key] = '=?' }

// Summon altmetric directive attributes this ones aren't part of the original Altmetric attributes
// @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
AltmetricsComposedScope['doc'] = '=?'
// @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
AltmetricsComposedScope['hasHeader'] = '=?'

const SummonAltmetrics = function ($timeout: ITimeoutService, translationService: TranslationService) {
   let altmetricsRunning = 0
   return {
      restrict: 'C',
      templateUrl: '/assets/summonAltmetrics.html',
      transclude: true,
      replace: true,
      scope: AltmetricsComposedScope,
      link(scope: any, elm: any, attrs: any) {
         const altmetricContent = elm.find('.altmetricContent')
         scope.altmetricsShowHideEvents = function (visible: any) {
            return $timeout(() => {
               this.elem.removeClass('altmetric-embed')
               return this.hasVisibleAltmetric = visible
            })
         }
         return scope.$watch('doc', function (doc: any) {
            if (!doc._hasAltmetric) { doc._hasAltmetric = false }
            if (!scope.hasVisibleAltmetric) { scope.hasVisibleAltmetric = false }
            altmetricContent.empty()
            altmetricContent.append(scope.elem = angular.element('<span />'))

            // Take dois or pmids based on doc model and set it to Altmetric attribute
            const object = { dois: 'data-doi', pmids: 'data-pmid' }
            for (var k in object) {
               // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
               var v = object[k]
               if (doc[k]?.length) {
                  scope.elem.attr(v, doc[k][0])
                  doc._hasAltmetric = true
               }
            }

            // Generate Altmetric element only when has Altmetric basic ID info
            if (doc._hasAltmetric) {
               let attr
               const attributes = {}
               for (attr of AltmetricsConfigAttributes) {
                  // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                  if (attrs[attr] && scope[attr]) { attributes[attr] = scope[attr] }
               }

               // For custom styles
               scope.elem.addClass('altmetricClass')

               // Setting Altmetric
               scope.elem.addClass('altmetric-embed')
               scope.elem.attr('data-template', 'summon')
               scope.elem.attr('data-link-target', '_blank')
               document.getElementsByClassName('altemtrics_details')
               // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
               for (key of Object.keys(attributes)) { scope.elem.attr('data-' + snake_case(key, '-'), attributes[key]) }

               /*
                  Notes for followed events:
                  - Better control for altmetric setting hasVisibleAltmetric when it is visible.
                  - Remove the initial 'altmetric-embed' because badges are being triggered each time _altmetric_embed_init is called (Scrolling down).
                  - This events require jQuery event namespaces.
               */

               scope.elem.on('altmetric:show', () => scope.altmetricsShowHideEvents(true))
               scope.elem.on('altmetric:hide', () => scope.altmetricsShowHideEvents(false))

               // Prevent multiple executions running it once per batch
               altmetricsRunning++
               return $timeout(function () {
                  altmetricsRunning--
                  if (!altmetricsRunning && '_altmetric_embed_init' in window) {
                     // @ts-expect-error TS(2304) FIXME: Cannot find name '_altmetric_embed_init'.
                     return _altmetric_embed_init()
                  }
               })
            }
         })
      }
   }
}

angular.module('summonApp.directives').directive('summonAltmetrics', ['$timeout', 'translationService', SummonAltmetrics])
